/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './style/servicePage.scss';

import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import TextContainer from "../textContainer/textContainer";
import {getImg, getImgSizes, getImgSources, pageScroller} from "../../util/utils";
import {Link, sendGaEvent, sendGaPageView} from '@dvrd/dvr-controls';
import {useNavigate} from 'react-router';
import {afterNavigate} from "../../util/navigationUtil";

export default function ServicePage() {
    const navigate = useNavigate();

    function onClickContact() {
        sendGaEvent('click', 'services', 'contactformulier');
        afterNavigate('/contact', false, 'contact', pageScroller, navigate);
    }

    // function onNavAbout(id: string) {
    //     return function () {
    //         afterNavigate('/', false, id, pageScroller, navigate);
    //     }
    // }

    function renderMeeting() {
        return (
            <TextContainer title='Werkwijze'>
                <label className='sub-title'>Kennismakingsgesprek en proefwandeling</label>
                <p>
                    <br/>
                    Wanneer u erover denkt om uw hond aan te melden bij Bowie's Hondenuitlaatservice, kunt u
                    contact met mij opnemen via het <Link onClick={onClickContact}>contactformulier</Link>.
                    Samen plannen wij het kennismakingsgesprek in. Ik kom bij u thuis langs om u en uw hond te
                    ontmoeten. Tijdens dit gesprek bespreken we zoal wat de wensen zijn van u en uw hond en of
                    er aandachtspunten zijn met betrekking tot uw hond. Het kennismakingsgesprek is gratis en ik
                    besteed hier onbeperkte tijd aan zodat alles rustig besproken kan worden. We plannen na het
                    kennismakingsgesprek een proefwandeling in. Na de proefwandeling bespreken we hoe de wandeling is
                    gegaan.
                </p>
            </TextContainer>
        )
    }

    function renderGroup() {
        return (
            <TextContainer invert>
                <h2 className='sub-title'>Groepswandeling</h2><br/>
                <p>
                    De honden worden opgehaald in een speciaal ingerichte bus,
                    voorzien van dakventilatie voor frisse lucht. Een wandeling duurt één uur tot 5 kwartier. Na
                    de wandeling worden de honden
                    thuisgebracht en dient er een handdoek klaar te liggen zodat de hond handdoek droog gemaakt
                    kan worden. In overleg kan de hond bij thuiskomst eten en eventueel medicatie krijgen.
                    Ik zal altijd controleren of de hond vers drinkwater
                    heeft.<br/><br/><strong>Eerste wandeling (10:30 - 11:30)</strong><br/> De honden worden voor de
                    eerste wandeling opgehaald tussen 09:00 uur en 10:30 uur.
                    <br/><br/><strong>Tweede wandeling (14:30 - 15:30)</strong><br/> De
                    honden worden voor de tweede wandeling opgehaald tussen 13:00 uur en 14:30 uur.<br/><br/>Bowie's
                    Hondenuitlaatservice wandelt op een eigen omheind veld, waar honden van alle leeftijden
                    het naar hun zin kunnen hebben. Op het veld zijn meerdere attributen geplaatst om de hond
                    een uitdaging te bieden tijdens het spelen.<br/><br/>
                    {/*De groepswandelingen worden verzorgd door <Link onClick={onNavAbout('leonique')}>Leonique</Link>.*/}
                </p>
                <img src={getImg('service/honden-veld-x480')}
                     srcSet={getImgSources('service/honden-veld', [300, 480])}
                     sizes={getImgSizes([300, 480], 480)} alt="Bowie's"
                     className='text-image'/>
            </TextContainer>
        );
    }

    // function renderPrivate() {
    //     return (
    //         <TextContainer invert>
    //             <h2 className='sub-title'>Individuele wandeling</h2><br/>
    //             <p>
    //                 Wanneer uw hond zich niet fijn voelt in een groep met andere honden, uw hond nog te jong is (jonger
    //                 dan 6 maanden) om mee te mogen met de groepswandeling of u een oudere hond heeft die het liever
    //                 wat rustiger aan doet, kunt u uw hond ook bij ons aanmelden voor een individuele
    //                 wandeling.<br/><br/>
    //                 Tijdens deze wandeling wordt er minimaal 30 minuten gewandeld in de eigen vertrouwde omgeving van de
    //                 hond waarmee we voor extra rust zorgen. Uiteraard mag u zelf bepalen hoelang u deze wandeling wilt
    //                 laten duren. Met de individuele wandeling is er volledige aandacht voor uw hond, wordt er veel
    //                 geknuffeld, gespeeld en wordt uw hond zowel fysiek als mentaal uitgedaagd zodat uw hond moe en
    //                 voldaan weer thuis komt.<br/><br/>
    //                 Na de wandeling wordt de hond thuisgebracht en dient er een handdoek klaar te liggen zodat de hond
    //                 handdoek droog gemaakt kan worden. In overleg kan de hond bij thuiskomst eten en eventueel medicatie
    //                 krijgen. We zullen altijd controleren of de hond vers drinkwater heeft.<br/><br/>
    //                 De individuele wandelingen kunnen momenteel alleen op maandag en dinsdag en worden verzorgd
    //                 door <Link onClick={onNavAbout('iris')}>Iris</Link>.
    //             </p>
    //             <img src={getImg('service/iris-hei-x480')}
    //                  srcSet={getImgSources('service/iris-hei', [300, 480])}
    //                  sizes={getImgSizes([300, 480], 480)} alt="Bowie's"
    //                  className='text-image'/>
    //         </TextContainer>
    //     )
    // }

    useEffect(() => {
        sendGaPageView('/werkwijze');
    }, []);

    return (
        <div className='service-page' id='service'>
            <Helmet>
                <title> Bowie's | Werkwijze</title>
                <link rel="canonical" href={`https://bowies.nl/werkwijze`}/>
            </Helmet>
            {renderMeeting()}
            {renderGroup()}
            {/*{renderPrivate()}*/}
        </div>
    )
}